import React from "react";
import { motion } from "framer-motion";
import { projekte } from "../../helper/data";

const DemokratieWahl = () => {
  const demokratieProject = projekte.find(
    (project) => project.titel === "Demokratie"
  );

  if (!demokratieProject) {
    return <p>Projekt nicht gefunden.</p>;
  }

  return (
    <div className="container my-4 text-center">
      <motion.div
        className="announcement bg-light p-4 p-md-5 rounded shadow text-start responsive-fs"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <img
          src={demokratieProject.images[0]}
          alt="Demokratie"
          className="img-fluid d-block rounded mb-3 mx-auto"
        />
        <h3 className="fw-semibold text-success mt-4">
          {demokratieProject.desc.toUpperCase()}
        </h3>

        <div>
          <strong>Projektzeitraum:</strong> 01.02.2025 – 16.03.2025
        </div>

        <div>
          <strong>Anzahl der geförderten Kinder:</strong> 30
        </div>

        <div>
          <h3 className="mt-3">{demokratieProject.titel2}</h3>
          <p className="justify-text">{demokratieProject.desc2}</p>
        </div>

        <div>
          <h3 className="mt-3">{demokratieProject.titel3}</h3>
          <p className="justify-text">{demokratieProject.desc3}</p>
        </div>

        <div>
          <h3 className="mt-3">{demokratieProject.titel4}</h3>
          <ul>
            <li className="justify-text">- {demokratieProject.desc41}</li>
            <li className="justify-text">- {demokratieProject.desc42}</li>
            <li className="justify-text">- {demokratieProject.desc43}</li>
          </ul>
        </div>

        <div>
          <h3 className="mt-3">{demokratieProject.titel5}</h3>
          <p className="justify-text fst-italic fw-semibold text-success">
            1. {demokratieProject.desc51}
          </p>
          <ul>
            <li className="justify-text">- {demokratieProject.desc511}</li>
            <li className="justify-text">- {demokratieProject.desc512}</li>
            <li className="justify-text">- {demokratieProject.desc513}</li>
          </ul>

          <p className="justify-text fst-italic fw-semibold text-success">
            2. {demokratieProject.desc52}
          </p>
          <ul>
            <li className="justify-text">- {demokratieProject.desc521}</li>
            <li className="justify-text">- {demokratieProject.desc522}</li>
            <li className="justify-text">- {demokratieProject.desc523}</li>
            <li className="justify-text">- {demokratieProject.desc524}</li>
          </ul>

          <p className="justify-text fst-italic fw-semibold text-success">
            3. {demokratieProject.desc53}
          </p>
          <ul>
            <li className="justify-text">- {demokratieProject.desc531}</li>
            <li className="justify-text">- {demokratieProject.desc532}</li>
          </ul>

          <p className="justify-text fst-italic fw-semibold text-success">
            4. {demokratieProject.desc54}
          </p>
          <ul>
            <li className="justify-text">- {demokratieProject.desc541}</li>
            <li className="justify-text">- {demokratieProject.desc542}</li>
          </ul>
        </div>

        <ul className="mt-3">
          <li>
            <a
              href={demokratieProject.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none"
            >
              {demokratieProject.link}
            </a>
          </li>
        </ul>

        <img
          src={demokratieProject.images[1]}
          alt="Demokratie"
          className="img-fluid d-block rounded mb-3 mx-auto"
        />
      </motion.div>
    </div>
  );
};

export default DemokratieWahl;
